/**
 * PATH: packages/email-hub/src/feature/pages/inbox-page/InboxStatusSurface.tsx
 * FILE_ID: EMAIL-INBOX-STATUS-SURFACE-001
 * PURPOSE: Render transient search and sweep status outside command-row chrome.
 */

import { SearchSyncBanner } from '../../components/SearchSyncBanner'
import type { InboxPageController } from './useInboxPageController'

export function InboxStatusSurface({ vm }: { vm: InboxPageController }) {
  const searchActive = !!vm.debouncedSearchQuery.trim()
  return (
    <div data-testid="inbox-transient-status">
      <SearchSyncBanner
        organisationId={vm.kanbanSession?.organisation?.id ?? null}
        userId={vm.kanbanSession?.user?.id ?? null}
        searchActive={searchActive}
        liveSearchOffered={vm.liveSearch.offered}
        onLiveSearch={vm.liveSearch.trigger}
      />
    </div>
  )
}
